<template>
  <div class="student-detail-card mt-6">
    <span class="font-weight-bold">Cập nhật thông tin chăm sóc/gia hạn</span>
    <validation-observer ref="validator" v-slot="{ handleSubmit }" >
      <div class="d-flex mt-4">
        <div class="d-flex">
          <div class="form-title" style="width: 70px;">Giai đoạn</div>
          <validation-provider
            v-slot="{ errors }"
            rules="required"
            name="Giai đoạn"
            style="width: 100%"
          >
            <v-select
              v-model="blendedNote.typeCustomerCare"
              item-text="name"
              item-value="id"
              :items="listTypeCustomer"
              class="ml-6"
              :error-messages="errors"
              @change="getListProductForFilter()"
              style="width: 200px; border-radius: 14px;"
              hide-details="auto" outlined dense>
            </v-select>
          </validation-provider>
        </div>
        <div class="d-flex product-area">
          <div class="form-title">{{ blendedNote.typeCustomerCare == 2 ? 'Sản phẩm cần gia hạn' : 'Sản phẩm'}}</div>
          <validation-provider
            v-slot="{ errors }"
            rules="required"
            :name="blendedNote.typeCustomerCare == 2 ? 'Sản phẩm cần gia hạn' : 'Sản phẩm'"
            style="width: 100%"
          >
            <v-select
              v-model="blendedNote.id"
              :items="listProductFilter"
              :disabled="!blendedNote.typeCustomerCare"
              item-text="name"
              item-value="id"
              class="ml-6"
              :error-messages="errors"
              @change="getListStatusForFilter()"
              style="width: 200px; border-radius: 14px;"
              hide-details="auto" outlined dense>
            </v-select>
          </validation-provider>
        </div>
        <div class="d-flex">
          <v-btn v-if="(studentBlendedTutorDetail.type_customer_care === 2 || studentBlendedTutorDetail.type_customer_care === 1  || studentBlendedTutorDetail.type_customer_care === 4) && checkChangeSalePermission() && studentBlendedTutorDetail.type_curriculum !== 'duo'" class="transfer-sales-button"
                 :loading="disableSubmit"
                 @click="transferToSaleExtend()">
            Chuyển sale
          </v-btn>
        </div>
      </div>
      <div class="d-flex mt-4">
        <div class="d-flex">
          <div class="form-title" style="width: 70px;">Trạng thái</div>
          <validation-provider
            v-slot="{ errors }"
            rules="required"
            name="Trạng thái"
            style="width: 100%"
          >
            <v-select
              v-model="blendedNote.callStatusId"
              :disabled="!blendedNote.id"
              :items="listStatusFilter"
              item-text="name"
              item-value="id"
              class="ml-6"
              :error-messages="errors"
              style="width: 200px; border-radius: 14px;"
              hide-details="auto" outlined dense>
            </v-select>
          </validation-provider>
        </div>
      </div>
      <div class="d-flex w-100 mt-4">
        <div class="d-flex w-100">
          <validation-provider
            v-slot="{ errors }"
            rules="required"
            name="Nhập thông tin chăm sóc/gia hạn"
            style="width: 80%;"
          >
            <v-text-field
              ref="blended-note"
              v-model="blendedNote.note"
              :error-messages="errors"
              hide-details="auto"
              placeholder="Nhập thông tin chăm sóc/gia hạn"
              outlined dense class="mr-3"
              maxlength="250"
              counter
              style="margin-top: 2px;">
            </v-text-field>
          </validation-provider>
          <v-btn :loading="disableSubmit" class="update-btn" @click="handleSubmit(createCareNote)">Cập nhật</v-btn>
        </div>
      </div>
    </validation-observer>
    <!--Xếp lớp-->
    <div class="care-form mt-4 d-flex align-center justify-center flex-column mb-5" style="padding-top: 16px" v-if="isShowSortClassTutor">
      <span style="font-size: 32px !important; font-weight: bold">Thời gian hết hạn xếp lớp: {{showCountdownTime}}</span>
      <v-btn color="#219653" style="color: white; margin-top: 32px" @click="handleSortClass">
        XẾP LỚP
      </v-btn>
    </div>
    <div class="care-form mt-4 d-flex align-center justify-center flex-column" style="padding-top: 16px" v-if="isShowChangeOperatorSection">
      <div style="font-size: 32px !important; font-weight: bold">Đã chuyển vận hành xếp lớp</div>
      <div style="margin-top: 16px">{{_.get(CLASS_ASSIGNMENT_CHANGE_REASON_OPTION.find((e) => e.value === this.reasonType), 'text', '')}} - {{changeOperatorLogTime}}</div>
    </div>
    <div class="d-flex">
      <div v-if="listCareOfSt && listCareOfSt.length" id="style-3" class="col-12 d-flex overflow-x-auto">
        <div
          class="item-care-content"
          v-for="itemCare in listCareOfSt" :key="itemCare.id"
          :style="`background-color: ${genCssByRgb(itemCare.color, '0.7')}; ${productSelected.id === itemCare.id ? 'border: 3px solid ' + itemCare.color : ''}`"
          :class="productSelected.id === itemCare.id ? 'selected' : ''"
          @click="filterListCareHistory(itemCare)"
        >
          {{ itemCare.name }}
        </div>
      </div>
    </div>
    <v-dialog v-model="modalDetailClass" :width="this.$vuetify.breakpoint.width < 1366 ? 1100 : 1200">
      <ModalDetailClass :studentCareInfo="studentBlendedTutorDetail" :studentProductId="studentBlendedTutorDetail.student_product_id" :closeModalDetailClass="closeModalDetailClass"></ModalDetailClass>
    </v-dialog>
  </div>
</template>

<script>
import { SORT_CLASS_PROGRAMS_NAME, CLASS_ASSIGNMENT_CHANGE_REASON_OPTION } from '@/modules/student_care/constant/constant';
import { mapActions, mapGetters, mapState } from 'vuex';
import TutorSortClassRepository from '@/services/TutorSortClassRepository';
import * as moment from 'moment/moment';
import ModalDetailClass from '@/modules/student_care/components/ModalDetailClass.vue';
import { SCHOOL_LEVEL, TYPE_CALL_STATUS } from '../../../helpers/constant';
import TokenService from '../../../helpers/token';
import ContactServices from '../../../services/ContactRepository';

export default {
  name: 'NoteCard',
  data() {
    return {
      SORT_CLASS_PROGRAMS_NAME,
      CLASS_ASSIGNMENT_CHANGE_REASON_OPTION,
      reasonType: null,
      changeOperatorLogTime: '',
      modalDetailClass: false,
      showCountdownTime: '',
      blendedNote: {
        id: null,
        typeCustomerCare: null,
        note: null,
        callStatusId: null,
      },
      listProductFilter: [],
      listStatusFilter: [],
      careStudentSelected: {},
      disableSubmit: false,
      blendedTutorTab: 1, // csđk
      isAllBtnClass: true,
      productSelected: {},
    };
  },
  components: { ModalDetailClass },
  props: {
    listCareOfSt: {
      type: Array,
      default: () => ([]),
    },
    listProduct: {
      type: Array,
      default: () => ([]),
    },
    listTypeCustomer: {
      type: Array,
      default: () => ([]),
    },
    recordDetail: {
      type: Object,
      default: () => ({
        // lms_core_user_id: 9559,
        // type_customer_care: 4,
        // type_curriculum: 'online',
      }),
    },
  },
  created() {
    // this.getCareStudentSelected();
    this.blendedNote.typeCustomerCare = 1;
    Bus.$on('change-filter-program', (params) => {
      if (params.tabActive === 1 || params.tabActive === 2 || params?.program?.type === 'tutor') {
        this.blendedNote.typeCustomerCare = 1;
        this.getListProductForFilter();
      }
      if (params.tabActive === 3 || params?.program?.type === 'duo') {
        this.blendedNote.typeCustomerCare = this.listTypeCustomer.find((e) => e.id === 2) ? 2 : null;
        this.getListProductForFilter();
        this.careStudentSelected = this.listProductFilter.find((e) => e.name === 'Duo');
        this.blendedNote.id = this.careStudentSelected?.id;
        this.listStatusFilter = this.allListStatus.find((e) => e.id === +this.careStudentSelected?.call_id)?.data;
      }
      if (params?.program?.type === 'tutor' && params?.program?.value) {
        this.careStudentSelected = this.listProductFilter.find((e) => e.curriculum_id === params.program.value);
        this.blendedNote.id = this.careStudentSelected?.id;
        this.listStatusFilter = this.allListStatus.find((e) => e.id === +this.careStudentSelected?.call_id)?.data;
      }
      if (!params?.program?.value && params?.tabActive === 1) {
        this.careStudentSelected = {};
        this.blendedNote = {
          id: null,
          typeCustomerCare: null,
          note: null,
          callStatusId: null,
        };
      }
      Bus.$emit('filter-list-care-history', this.careStudentSelected);
    });
  },
  methods: {
    ...mapActions('student_care', ['apiUpdate']),
    closeModalDetailClass() {
      this.modalDetailClass = false;
    },
    handleSortClass() {
      this.modalDetailClass = true;
    },
    formatTimeUnit(timeUnit) {
      return timeUnit < 10 ? `0${timeUnit}` : timeUnit;
    },
    countdownTime(timeDiff) {
      // eslint-disable-next-line no-underscore-dangle
      const dd = Math.abs(timeDiff._data.days);
      // eslint-disable-next-line no-underscore-dangle
      let hh = Math.abs(timeDiff._data.hours);
      // eslint-disable-next-line no-underscore-dangle
      let mm = Math.abs(timeDiff._data.minutes);
      // eslint-disable-next-line no-underscore-dangle
      let ss = Math.abs(timeDiff._data.seconds);
      hh += dd * 24;
      const countdownInterval = setInterval(() => {
        if (ss === 0) {
          if (mm === 0) {
            if (hh !== 0) {
              hh -= 1;
              mm = 59;
              ss = 59;
            } else {
              clearInterval(countdownInterval);
            }
          } else {
            mm -= 1;
            ss = 59;
          }
        } else {
          ss -= 1;
        }
        this.showCountdownTime = `${this.formatTimeUnit(hh)}:${this.formatTimeUnit(mm)}:${this.formatTimeUnit(ss)}`;
      }, 1000);
    },
    setTimerSortClass() {
      const timeDiff = moment.duration(moment(new Date()).diff(moment(this.timeSortClass)));
      this.countdownTime(timeDiff);
    },
    async getSortClassInfo() {
      const res = await TutorSortClassRepository.getSortClassInfo(this.studentBlendedTutorDetail.id);
      if (res.message === 'Success') {
        this.timeSortClass = res.data.deadlineSortClass;
        this.reasonType = res.data.reasonType;
        this.changeOperatorLogTime = res.data.logTime;
      }
    },
    checkChangeSalePermission() {
      const { schoolLevel } = this.$route.query;
      if (schoolLevel === SCHOOL_LEVEL.PRIMARY) {
        return this.checkAuthorization('move-sale-bl_read');
      }
      if (schoolLevel === SCHOOL_LEVEL.SECONDARY) {
        return this.checkAuthorization('move-sale-bl-secondary_read');
      }
      return false;
    },
    async createCareNote() {
      const { schoolLevel } = this.$route.query;
      // eslint-disable-next-line no-nested-ternary
      const condition = schoolLevel === SCHOOL_LEVEL.PRIMARY ? !this.checkAuthorization('blended-tutor-student-detail_update') : schoolLevel === SCHOOL_LEVEL.SECONDARY ? !this.checkAuthorization('blended-tutor-secondary-student-detail_update') : false;
      if (condition) {
        this.$swal({
          type: 'error',
          title: 'Lỗi!',
          text: 'Bạn không có quyền cập nhật. Vui lòng liên hệ Admin!',
        });
        return;
      }
      if (_.isEmpty(this.careStudentSelected) || !this.careStudentSelected) return;
      this.disableSubmit = true;
      const user = TokenService.getUser();
      const body = {
        routine_student_id: this.careStudentSelected.id,
        call_id: this.careStudentSelected.call_id,
        call_name: this.mapCallStatus && this.mapCallStatus[this.careStudentSelected.call_status_id] ? this.mapCallStatus[this.careStudentSelected.call_status_id].callType : '',
        note: this.blendedNote.note,
        subject_id: this.careStudentSelected.subject_id,
        call_status_id: this.blendedNote.callStatusId,
        call_status_name: this.mapCallStatus && this.mapCallStatus[this.blendedNote.callStatusId] ? this.mapCallStatus[this.blendedNote.callStatusId].callStatus : '',
        created_name: user.username,
        created_by: user.id,
        lms_core_user_id: this.careStudentSelected.lms_core_user_id,
        curriculum_id: this.careStudentSelected.curriculum_id,
        type_curriculum: this.careStudentSelected.type_curriculum,
        type_customer_care: this.careStudentSelected.type_customer_care,
        type_blended: 2,
      };
      const oldData = {
        call_name: body.call_name,
        call_status_name: this.mapCallStatus[this.careStudentSelected.call_status_id].callStatus,
      };
      const params = {
        obj: 'call-histories-detail',
        data: body,
        oldData,
      };
      const response = await this.apiUpdate(params);
      if (response) {
        this.$swal({
          type: 'success',
          icon: 'success',
          title: 'Tạo thành công !',
          toast: true,
          showConfirmButton: false,
          timer: 1500,
        });
        if (_.isEmpty(this.productSelected) || !this.productSelected) {
          this.blendedNote = {
            id: null,
            typeCustomerCare: null,
            note: null,
            callStatusId: null,
          };
        } else {
          this.blendedNote.note = null;
          this.blendedNote.callStatusId = null;
        }
        this.$nextTick(() => {
          this.$refs.validator.reset();
        });
        this.$refs['blended-note'].blur();
        Bus.$emit('reload-list-care-history', this.productSelected);
        Bus.$emit('reload-list-product', {
          id: this.careStudentSelected?.id,
          call_status_id: body.call_status_id,
        });
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Có lỗi xảy ra khi tạo note!!!',
        });
      }
      this.disableSubmit = false;
    },
    filterListCareHistory(item) {
      if (item.id === this.productSelected.id) {
        this.productSelected = {};
      } else {
        this.productSelected = item;
      }
      Bus.$emit('filter-list-care-history', this.productSelected);
    },
    getListProductForFilter() {
      let typeCustomerCareArr = [];
      if (this.blendedNote.typeCustomerCare === 1) {
        typeCustomerCareArr = [TYPE_CALL_STATUS.C0, TYPE_CALL_STATUS.CHAM_SOC_DINH_KY];
      } else if (this.blendedNote.typeCustomerCare === 2) {
        typeCustomerCareArr = [TYPE_CALL_STATUS.GIA_HAN, TYPE_CALL_STATUS.CHUYEN_SALES];
      }
      this.listProductFilter = this.listProduct.filter((e) => typeCustomerCareArr.includes(e.type_customer_care));
    },
    getListStatusForFilter() {
      this.careStudentSelected = this.listProduct.find((e) => e.id === this.blendedNote.id);
      if (!this.careStudentSelected) return;
      this.listStatusFilter = this.allListStatus.find((e) => e.id === +this.careStudentSelected.call_id)?.data;
    },
    getCareStudentSelected() {
      if (!this.isAllBtnClass || this.blendedTutorTab !== 1) {
        this.blendedNote.typeCustomerCare = [TYPE_CALL_STATUS.CHAM_SOC_DINH_KY, TYPE_CALL_STATUS.C0].includes(this.recordDetail.type_customer_care) ? 1 : 2;
        this.getListProductForFilter();
      }
      if (this.recordDetail.type_curriculum === 'duo') {
        this.blendedNote.id = this.listProduct.find((e) => e.type_curriculum === 'duo')?.id;
      }
    },
    genCssByRgb(color, op) {
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(color.substring(0, 7));
      return result ? `rgb(${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}, ${op})` : '';
    },
    async transferToSaleExtend() {
      this.$swal({
        title: 'Bạn có chắc muốn chuyển sang Chuyển sales',
        confirmButtonText: 'Đồng ý',
        showCancelButton: true,
        cancelButtonText: 'Huỳ bỏ',
        // eslint-disable-next-line consistent-return
      }).then(async (res) => {
        this.disableSubmit = true;
        if (res.value) {
          const result = await ContactServices.updateSale({
            ids: [this.studentBlendedTutorDetail.id],
          });
          this.disableSubmit = false;
          if (result.message === 'Success') {
            this.$swal({
              type: 'success',
              title: 'Thành công',
              text: 'Chuyển sang Chuyển sales thành công!!!',
            });
            window.location.reload();
            return true;
          }
          return this.$swal({
            type: 'error',
            title: 'Lỗi !',
            text: 'Có lỗi khi chuyển sang Chuyển sales !!!',
          });
        }
        this.disableSubmit = false;
      });
    },
  },
  computed: {
    ...mapState('contact_status', ['allListStatus']),
    ...mapGetters('contact_status', ['mapCallStatus', 'mapProgramIdAndProgram']),
    ...mapGetters('student_care', ['mapProgramIdAndProgram']),
    ...mapState('student_detail_bt', ['studentBlendedTutorDetail', 'activeCurriculumId']),
    isShowSortClassTutor() {
      return (_.get(this.mapCallStatus[this.studentBlendedTutorDetail.call_status_id], 'callType', '') === 'TA0'
        && _.get(this.studentBlendedTutorDetail, 'careTagsMongo', []).some((e) => e.name === 'Chờ xếp lớp')
        && SORT_CLASS_PROGRAMS_NAME.includes(_.get(this.mapProgramIdAndProgram[this.studentBlendedTutorDetail.curriculum_id], 'title', ''))
        && this.$route.query.schoolLevel === 'primary');
    },
    isShowChangeOperatorSection() {
      return (_.get(this.mapCallStatus[this.studentBlendedTutorDetail.call_status_id], 'callType', '') === 'TA0'
        && _.get(this.studentBlendedTutorDetail, 'careTagsMongo', []).some((e) => e.name === 'Chuyển vận hành')
        && SORT_CLASS_PROGRAMS_NAME.includes(_.get(this.mapProgramIdAndProgram[this.studentBlendedTutorDetail.curriculum_id], 'title', ''))
        && this.$route.query.schoolLevel === 'primary');
    },
  },
  watch: {
    async isShowSortClassTutor(val) {
      if (val) {
        await this.getSortClassInfo();
        this.setTimerSortClass();
      }
    },
    async isShowChangeOperatorSection(val) {
      if (val) {
        await this.getSortClassInfo();
      }
    },
    listProduct: {
      deep: true,
      handler() {
        // this.getCareStudentSelected();
        this.getListProductForFilter();
      },
    },
    productSelected: {
      deep: true,
      handler(newVal) {
        this.getCareStudentSelected();
        if (newVal && newVal.type_customer_care) {
          this.blendedNote.typeCustomerCare = [TYPE_CALL_STATUS.CHAM_SOC_DINH_KY, TYPE_CALL_STATUS.C0].includes(newVal.type_customer_care) ? 1 : 2;
          this.blendedNote.id = newVal?.id;
          this.getListStatusForFilter();
          this.getListProductForFilter();
        } else if (_.isEmpty(newVal)) {
          this.blendedNote = {
            id: null,
            typeCustomerCare: null,
            note: null,
            callStatusId: null,
          };
        }
      },
    },
  },
  beforeDestroy() {
    Bus.$off('change-filter-program');
  },
};
</script>

<style scoped>
.update-btn {
  opacity: 0.6;
  background:
    #27C100 !important;
  border-radius: 18px;
  color: white;
  font-weight: bold;
}
.student-detail-card {
  background: white;
  border-radius: 12px;
  width: 98%;
  padding: 0px 16px;
}
.status-box {
  background: #16C7F9;
  border-radius: 20px;
  color: white;
  font-weight: bold;
  font-size: 12px;
  padding: 8px 18px;
  margin: 0 8px;
}
.item-care-content {
  border-radius: 12px;
  font-size: 13px;
  /*height: 30px;*/
  font-weight: bold;
  color: white;
  width: 200px;
  padding: 3px 15px;
  margin-right: 30px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;
  cursor: pointer;
  line-height: 1.1;
}

.form-title {
  font-weight: bold;
  white-space: nowrap;
  margin-top: 10px;
}
.item-care-content.selected {
  border: 3px solid #181717;
}
.transfer-sales-button {
  background-color: #cd91d7 !important;
  width: 105px;
  height: 36px;
  margin-left: 320px;
  color: white;
  font-weight: bold;
}
.product-area {
  margin-left: 100px;
}

@media screen and (max-width: 1440px) {
   .transfer-sales-button {
      margin-left: 20px;
   }
   .product-area {
      margin-left: 0px;
   }
}
</style>
